import { IActionWithPayload } from "store/helper";

import { AgentsViewAction, AgentsViewActionsNames } from "./actions";
import {
  IFetchLiveChatAgentsSuccessPayload,
  ILiveChatAgent,
  ISetFocusedColumnPayload,
  ISetSelectedAgentPayload,
  ISort,
} from "./interfaces";

export interface IAgentsViewState {
  selectedAgentId: string;
  focusedColumn: number;
  sort: ISort;
  sortLoggedInAgentOnTop: boolean;
  livechatAgents: ILiveChatAgent[] | null;
}

const initialState: IAgentsViewState = {
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
  selectedAgentId: null,
  focusedColumn: 0,
  sort: {
    field: "name",
    desc: false,
  },
  sortLoggedInAgentOnTop: true,
  livechatAgents: null,
};

export function agentsViewReducer(state: IAgentsViewState = initialState, action: AgentsViewAction): IAgentsViewState {
  switch (action.type) {
    case AgentsViewActionsNames.SET_SELECTED_AGENT: {
      const { payload } = action as IActionWithPayload<string, ISetSelectedAgentPayload>;
      const { selectedAgentId } = payload;
      return {
        ...state,
        selectedAgentId,
      };
    }

    case AgentsViewActionsNames.SET_FOCUSED_COLUMN: {
      const { payload } = action as IActionWithPayload<string, ISetFocusedColumnPayload>;
      const { focusedColumn } = payload;
      return { ...state, focusedColumn };
    }

    case AgentsViewActionsNames.SET_LIST_SORTING: {
      const { payload } = action as IActionWithPayload<string, ISort>;
      const { field, desc } = payload;
      return {
        ...state,
        sortLoggedInAgentOnTop: false,
        sort: { field, desc },
      };
    }

    case AgentsViewActionsNames.FETCH_LIVECHAT_AGENTS_SUCCESS: {
      const { payload } = action as IActionWithPayload<string, IFetchLiveChatAgentsSuccessPayload>;
      const livechatAgents = payload.values;
      return {
        ...state,
        livechatAgents,
      };
    }

    default:
      return state;
  }
}
